Namespace 'Monitoring.Models.SocialContents.LinkedIn.Serializers'

class Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInCommentSerializer
  serialize: (linkedInCommentContent) ->
    {
      parentId: linkedInCommentContent.getParentId(),
      parentCommentId: linkedInCommentContent.getParentCommentId()
      mainText: linkedInCommentContent.getMainText(),
      createdAt: linkedInCommentContent.getCreatedAt(),
      contentID: linkedInCommentContent.getCondition(),
      isBrandContent: linkedInCommentContent.getIsBrandContent(),
      subType: linkedInCommentContent.getSubType()
    }

  deserialize: (json) ->
    builder = new Monitoring.Models.SocialContents.LinkedIn.Builders.LinkedInCommentBuilder
    builder.setParentPostId(json.parent_post_id)
    builder.setParentCommentId(json.parent_comment_id)
    builder.setText(json.text)
    builder.setCreatedAt(json.interaction.created_at)
    builder.setContentId(json.content_id)
    builder.setIsBrandContent(json.is_brand_content)
    linkedInComment = builder.build()
    authorSerializer = new Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInAuthorSerializer()
    linkedInAuthor = authorSerializer.deserialize(json.author)
    new Monitoring.Models.SocialContents.LinkedIn.LinkedInCommentContent(linkedInAuthor, linkedInComment)
